import type { Nullable } from "types/utilities";
import { authFetch } from "../utils/authFetch";
import type {
  OtpVerificationChannel,
  OtpVerificationPurpose,
} from "../utils/types";

export type InitOtpResponse = {
  destination: string;
  channel: string;
  retryAfter: string;
  expiresAt: string;
  remainingAttempts: number;
  verificationRequestId: string;
};

export type VerifyOtpResponse = {
  destination: string;
  channel: string;
  status: "SUCCESS" | "FAILURE" | "EXPIRED";
  validUntil: string;
  remainingAttempts: number;
  verificationRequestId: string;
};

export const initOtpVerification = (
  destination: string,
  channel: OtpVerificationChannel,
  purpose: OtpVerificationPurpose,
  token: Nullable<string>,
) =>
  authFetch<InitOtpResponse>("/secondary-verifications/init", {
    method: "POST",
    token,
    body: {
      destination,
      channel,
      purpose,
    },
  });

export const verifyOtp = (
  destination: string,
  code: string,
  verificationRequestId: string,
  channel: OtpVerificationChannel,
  token: Nullable<string>,
) =>
  authFetch<VerifyOtpResponse>("/secondary-verifications/verify", {
    method: "POST",
    token,
    body: {
      destination,
      channel,
      code,
      verificationRequestId,
    },
  });
